import { NestedEditorRow } from "./nestedRowTypes";

// Passing a display-key row id into a per-id op matches nothing (fan-out required).
export const forEachAccountConstituent = (
    row: NestedEditorRow,
    apply: (accountId: string) => void,
): void => {
    for (const account of row.accounts) {
        apply(account.id);
    }
};

export const forEachGroupConstituent = (
    row: NestedEditorRow,
    apply: (groupId: string) => void,
): void => {
    for (const group of row.groups) {
        apply(group.id);
    }
};
